<template>
    <div class="rcclQN">

        <div class="royalBanner">
            <div class="royalBanner--content">
                <img style="width: 100%;" v-for="(category, i) in categories" :key="('category_img_'+i)"
                    :src="category.bannerImageUrl" :alt="category.category" v-show="category.category==currentCategory">
                <div class="banner-shadow"></div>
            </div>
            <div class="royalBanner__arrowLeft" @click="onArrowClick('prev')">
                <img src="https://resource.rcclchina.com.cn/rcclQN/image/arrowLeftY.png">
                </div>
            <div class="royalBanner__arrowRight" @click="onArrowClick('next')">
                <img src="https://resource.rcclchina.com.cn/rcclQN/image/arrowRightY.png">
            </div>
        </div>
        
        <div class="intro-contentItem">
            <div class="intro-content" v-for="(category, i) in categories" :key="('category_'+i)"
            v-show="category.category==currentCategory">
                <div class="title1">
                    {{category.contentTitle}}
                </div>
                <div class="title2">
                    {{category.contentSubTitle}}
                </div>
                <div class="title3">
                    {{category.contentDescription}}
                </div>
            </div>
           
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
export default {
    name: "ExperienceBanner",
    props: {
        categories: {
            type: Array,
            default () {
                return []
            }
        },
        initCategory: {
            type: String,
            default () {
                return ""
            }
        },
        onCategoryChange: {
            type: Function
        }
    },
    data () {
        return {
            currentCategory: this.initCategory+""
        }
    },
    methods: {
        onArrowClick (type) {
            const currentIndex = _.findIndex(this.categories, (o) => {
                return o.category == this.currentCategory
            })
            if (currentIndex < 0) {
                return
            }
            let index = 0
            if (type == 'prev') {
                if (currentIndex == 0) {
                    index = this.categories.length - 1
                } else {
                    index = currentIndex - 1
                }
            } else if (type == 'next') {
                if (currentIndex == this.categories.length - 1) {
                    index = 0
                } else {
                    index = currentIndex + 1
                }
            }
            this.currentCategory = this.categories[index].category
            this.onCategoryChange(this.currentCategory)
        }
    },
    watch: {
        initCategory (newValue) {
            this.currentCategory = newValue
        }
    }
}
</script>

<style lang="less" scoped>
.rcclQN {
    position: relative;
    width: 100%;
    color: #fff;
    .royalBanner--content {
        max-height: 492px;
        position: relative;
        width: 100%;
        overflow: hidden;
        .banner-shadow {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #000;
            opacity: .2;
        }
    }
    .royalBanner__arrowLeft {
        position: absolute;
        top: 300px;
        left: 100px;
        cursor: pointer;
    }
    .royalBanner__arrowRight {
        position: absolute;
        top: 300px;
        right: 100px;
        cursor: pointer;
    }
    .intro-content {
        .title1 {
            font-size: 32px;
            position: absolute;
            top: 170px;
            width: 100%;
            text-align: center;
            font-weight: 500;
        }
        .title2 {
            font-size: 16px;
            position: absolute;
            top: 230px;
            width: 100%;
            text-align: center;
        }
        .title3 {
            font-size: 16px;
            position: absolute;
            top: 270px;
            width: 100%;
            text-align: center;
        }
    }
}
</style>